<!--
 @description view 设置页
 @author huangzhijie
 @date 2018/11/13
-->
<style>
  .view-config {
    position: relative;
    height: 100%;
  }
  .view-config--form {
    float: left;
    box-sizing: border-box;
    padding: 16px;
    width: 360px;
    height: 100%;
    border: 1px solid rgba(0,0,0,0.15);
    background: #F5F5F5;
    overflow-y: auto;
  }
  .view-config--form-title {
    line-height: 36px;
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.65);
  }
  .view-config--form-title:after,
  .view-config--form-title:before, {
    display: table;
    content: ""
  }
  .view-config--form__border-t {
    border-top: 1px dashed rgba(0,0,0,0.15);
  }
  .view-config--form__close {
    float: right;
    font-size: 16px;
    line-height: 36px;
    width: 20px;
    cursor: pointer;
    text-align: center;
    color: rgba(0,0,0,0.45);
  }
  .view-config--form__close:hover {
    color: #FF4949;
  }
  .view-config-chart {
    box-sizing: border-box;
    padding-left: 380px;
    width: 100%;
    height: 100%;
  }
</style>
<template>
  <div class="view-config">
    <back :history="history"></back>
    <div class="view-config--form">
      <el-form ref="viewform"
        input-width="auto"
        label-width="60px"
        :model="formModel"
        :rules="formRules">
        <el-form-item
          key="name"
          prop="name"
          label-width="0">
          <el-row :gutter="16">
            <el-col :span="14">
              <el-input v-model="formModel.name"></el-input>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="e_save" v-text="$t('common.save')"></el-button>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" @click="e_run" v-text="$t('view.run')"></el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <template v-if="chartType != 'PIE'">
          <div class="view-config--form-title" v-text="$t('view.xConfig')"></div>
          <el-form-item 
            key="x.name"
            prop="x.name"
            label="Name : ">
            <el-input v-model="formModel.x.name"></el-input>
          </el-form-item>
          <el-form-item
            key="x.type"
            prop="x.type"
            label="Type : ">
            <el-select v-model="formModel.x.type">
              <el-option
                v-for="(sitem, skey) in xAxisTypeList"
                :key="skey"
                :label="sitem"
                :value="skey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item 
            key="x.field"
            prop="x.field"
            label="Field : ">
            <el-select v-model="formModel.x.field">
              <el-option
                v-for="(sitem, skey) in xAxisFieldList"
                :key="skey"
                :label="sitem"
                :value="skey">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <div v-for="(yItem, index) in formModel.y"
          :key="index">
          <div class="view-config--form-title view-config--form__border-t">
            {{ chartType == 'PIE' ? $t('view.labelConfig') : $t('view.yConfig') }}
            <i v-if="formModel.y.length != 1" class="uk-icon-circle-close view-config--form__close" @click="e_deleteYfield(index)"></i>
          </div>
          <el-form-item 
            :key="'y.'+index+'.name'"
            :prop="'y.'+index+'.name'"
            label="Name : ">
            <el-input v-model="yItem.name"></el-input>
          </el-form-item>
          <!-- <el-form-item 
            :key="'y.'+index+'.type'"
            :prop="'y.'+index+'.type'"
            label="Type : ">
            <el-select v-model="yItem.type" disabled>
              <el-option
                v-for="(sitem, skey) in yAxisTypeList"
                :key="skey"
                :label="sitem"
                :value="skey">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item 
            :key="'y.'+index+'.field'"
            :prop="'y.'+index+'.field'"
            label="Field : ">
            <el-select v-model="yItem.field" >
              <el-option
                v-for="(sitem, skey) in yAxisFieldList"
                :key="skey"
                :label="sitem"
                :value="skey">
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="formModel.series">
            <div class="view-config--form-title" v-text="$t('view.sConfig')"></div>
            <el-form-item 
              key="series"
              prop=""
              label="Field : ">
              <el-select v-model="formModel.series">
                <el-option
                  v-for="(sitem, skey) in xAxisFieldList"
                  :key="skey"
                  :label="sitem"
                  :value="skey">
                </el-option>
              </el-select>
            </el-form-item>
          </template>
          
        </div>
        
        <el-form-item v-if="chartType == 'LINE' || chartType == 'AREA'">
          <el-button  
            v-if="!formModel.series" 
            type="primary" 
            @click="e_addYfield" 
            v-text="$t('view.addYfield')">
          </el-button>
          <el-button 
            type="primary" 
            @click="e_addSeries" 
            v-text="formModel.series ? $t('view.closeSeries') : $t('view.addSeries')">
          </el-button>
        </el-form-item>

        <el-form-item v-if="chartType == 'BAR'">
          <el-button type="primary" @click="e_addYfield" v-text="$t('view.addYfield')"></el-button>
        </el-form-item>

        <el-form-item v-if="chartType == 'PIE'">
            <el-button type="primary" @click="e_addYfield" v-text="$t('view.addLabel')"></el-button>
          </el-form-item>
      </el-form>
    </div>
    <div class="view-config-chart">
      <chart ref="viewChart" chart-id="viewChart" :chart-data="chartData" :chart-style="chartStyle" :type="chartType"></chart>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import back from '@/components/back.vue'
import ViewBiz from '@/logic/intelligentMonitor/viewBiz'
import ITDeviceMonitorBiz from '@/logic/intelligentMonitor/ITDeviceMonitorBiz'
import TimeFormat from '@/utils/timeFormat'
import chart from '@/components/chart/chart-base'
import validateConfig from '@/utils/validate'
import { extend } from '@/utils/tool'

const TYPE_MAP = {
  'Histogram': 'BAR',
  'Area': 'AREA',
  'Line': 'LINE',
  'Pie': 'PIE'
}
export default {
  components: {
    back,
    chart
  },
  data () {
    return {
      history: [],
      dExtend: null,
      id: '',
      appName: '',
      dataSourceId: '',
      dataSourceName: '',
      group: '',
      kpiKey: '',
      type: '',
      formRules: {
        name: [{ ...validateConfig.common.notEmpty }]
      },
      formModel: {
        name: '',
        x: {
          name: '',
          field: '',
          type: ''
        },
        y: [],
        series: ''
      },
      xAxisTypeList: {
        category: 'category',
        time: 'time'
      },
      xAxisFieldList: {},
      yAxisTypeList: {
        value: 'value'
      },
      yAxisFieldList: {},
      primaryData: null,
      chartType: '',
      chartData: null,
      chartStyle: {},
      timer: null,
      isCustomData: false
    }
  },
  computed: {
    ...mapState({
      mPage: state => state.pageModule.data
    })
  },
  watch: {
  },
  methods: {
    async init () {
      await this.getSearchParam()

      this.setHistory()

      // 常规数据
      if (this.kpiKey) {
        this.isCustomData = false
        this.getKpiField()

        if (this.formModel.series) {
          const groupField = this.formModel.series.replace(/(data\.)/, '') // 去掉data.
          await this.getChartData(groupField)
        } else {
          await this.getChartData()
        }

        if (this.id) {
          this.getViewInfo()
        }
      } else {
        this.isCustomData = true
        // 自定义数据
        await this.getChartDataCustomData(this.dataSourceId)

        if (this.id) {
          this.getViewInfo()
        }
      }
    },
    setHistory () {
      const historyMap = {
        'Area': this.$t('view.chartArea'),
        'Line': this.$t('view.chartLine'),
        'Histogram': this.$t('view.chartHistogram'),
        'Pie': this.$t('view.chartPie'),
        'Table': this.$t('view.tableTable')
      }
      this.history = []
      this.history.push({
        name: `${this.$t('view.selectChart')}（${historyMap[this.type]}）`,
        path: '/home/view/viewChartSelect'
      })
      this.history.push({
        name: `${this.$t('view.selectDataSource')}（${this.dataSourceName}）`,
        path: `/home/view/viewDataSelect?type=${this.type}`
      })
      this.history.push({
        name: this.$t('view.dataConfigView')
      })
    },
    getSearchParam () {
      return new Promise((resolve, reject) => {
        // const viewInfo = this.mPage['view']
        const viewInfo = this.$route.query
        this.appName = viewInfo.appName
        this.group = viewInfo.group
        this.kpiKey = viewInfo.kpiKey
        this.dataSourceName = viewInfo.dName
        this.type = viewInfo.type
        this.chartType = TYPE_MAP[this.type]

        if (viewInfo.viewId) {
          this.id = viewInfo.viewId
        }
        if (viewInfo.dId) {
          this.dataSourceId = viewInfo.dId
        }
        if (viewInfo.series) {
          this.formModel.series = viewInfo.series
        }
        resolve()
      })
    },
    getViewInfo () {
      ViewBiz.findViewById({id: this.id}).then((data) => {
        this.formModel.x = data.param.x
        this.formModel.y = data.param.y
        this.formModel.name = data.name
        this.dataSourceName = data.extend ? data.extend.name : data.name
        this.dExtend = data.extend
        this.type = data.type
        this.chartType = TYPE_MAP[this.type]

        this.e_run()
      })
    },
    getChartStyle ({title, xName, type}) {
      const result = {
        title: {
          text: title,
          padding: 10
        },
        grid: {
          left: '4%',
          right: '4%',
          top: '10%',
          bottom: '10%',
          containLabel: true
        }
      }

      if (type !== 'PIE') {
        result.xAxis = {
          name: xName,
          nameLocation: 'middle',
          nameGap: 35
        }
      }

      return result
    },
    setChartStyle () {
      const title = this.formModel.name
      const xName = this.formModel.x.name
      this.chartStyle = extend(true, {}, this.getChartStyle({
        title,
        xName,
        type: this.chartType
      }))
    },
    drawChart () {
      if (this.isCustomData && !(this.primaryData instanceof Array)) {
        // 把数据转换为指定字段
        try {
          const dataKey = this.formModel.y[0].field.split('.')
          let dd = this.primaryData
          for (var i = 1; i < dataKey.length - 1; i++) {
            dd = dd[dataKey[i]]
          }
          if (this.chartType === TYPE_MAP.Pie) {
            this.primaryData = [dd]
          } else {
            this.primaryData = dd
          }
        } catch (err) {
          this.$message({
            message: this.$t('view.drawFail'),
            type: 'error'
          })
        }
      }
      const chartData = ViewBiz.viewHelper.chartDataHandle({
        name: this.formModel.name,
        data: this.primaryData,
        x: this.formModel.x,
        y: this.formModel.y,
        isSeries: this.formModel.series
      })

      if (chartData) {
        this.chartData = chartData
      } else {
        this.$message({
          message: this.$t('view.drawFail'),
          type: 'error'
        })
      }
    },
    getKpiField () {
      ViewBiz.getKpiField().then((data) => {
        const d = ViewBiz.dataHelper.filterKpiData(data)
        this.xAxisFieldList = this.yAxisFieldList = d
        this.formModel.x.field = d[Object.keys(d)[0]]

        this.e_addYfield()
      })
    },
    getChartData (groupField) {
      let searchData = {
        startTime: TimeFormat.getToday(),
        endTime: new Date().getTime(),
        group: this.group,
        kpiKey: this.kpiKey,
        appName: this.appName
      }
      if (groupField) {
        searchData.groupField = groupField
      }
      return ITDeviceMonitorBiz.getChartData(searchData).then((data) => {
        this.primaryData = data
        // this.primaryData = TEST_DATA
      })
    },
    getChartDataCustomData (id) {
      return ViewBiz.getSourceData({
        id: id
      }).then((d) => {
        // console.info('getSourceData', d)
        if (d.resultCode && d.resultCode !== '00000000') {
          this.$message({
            message: `${this.$t('view.dataSourceError')}: ${d.resultDesc}`,
            type: 'error'
          })
        } else {
          this.handerCustomData(d)
        }
      })
    },
    handerCustomData (data) {
      ViewBiz.dataHelper.filterData(data)
      let filterDatas = ViewBiz.dataHelper.getFilterObj()
      let fieldObj = {}
      Object.keys(filterDatas).map((item) => {
        if (filterDatas[item].indexOf('.') !== -1) {
          fieldObj[filterDatas[item]] = filterDatas[item]
        }
      })

      this.xAxisFieldList = this.yAxisFieldList = fieldObj
      this.formModel.x.field = fieldObj[Object.keys(fieldObj)[0]]

      this.e_addYfield()

      this.primaryData = data.data

      // if (!this.showSeries || this.$route.query.series) {
      //   this.select_sfield = fieldObj
      // }
      // this.select_xfield = this.select_yfield = fieldObj
      // if (this.$route.query.series) {
      //   let groupField = this.findLastArr(this.$route.query.series)
      //   this.searchGroupField(groupField, true)
      // } else {
      //   this.isHaveView()
      // }
    },
    resetData () {
      this.dExtend = ''
      this.id = ''
      this.appName = ''
      this.dataSourceId = ''
      this.dataSourceName = ''
      this.group = ''
      this.kpiKey = ''
      this.type = ''
      this.formModel = {
        name: '',
        x: {
          name: '',
          field: '',
          type: 'category'
        },
        y: [],
        series: ''
      }
    },
    e_save () {
      const name = this.formModel.name
      const type = this.type
      let dExtend = this.dExtend
      let param = extend(true, {}, this.formModel)
      delete param.name
      if (param.series.length === 0) {
        delete param.series
      }
      param = JSON.stringify(param)
      if (dExtend) {
        dExtend = {
          appName: this.appName,
          group: this.group,
          kpiKey: this.kpiKey,
          name: this.dataSourceName
        }
      }

      if (this.dataSourceId) {
        const sourceId = this.dataSourceId
        ViewBiz.saveView({
          name,
          sourceId,
          type,
          param,
          extend: dExtend
        }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        })
      } else {
        const id = this.id
        ViewBiz.saveView({
          name,
          id,
          type,
          param,
          extend: dExtend
        }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        })
      }
    },
    e_run () {
      this.$refs['viewform'].validate((valid) => {
        if (valid) {
          this.setChartStyle()
          setTimeout(this.drawChart)
        } else {
          return false
        }
      })
    },
    e_addYfield () {
      this.formModel.y.push({
        name: '',
        field: this.yAxisFieldList[Object.keys(this.yAxisFieldList)[0]]
      })
    },
    e_deleteYfield (index) {
      this.formModel.y.splice(index, 1)
    },
    e_addSeries () {
      if (this.formModel.series) {
        this.formModel.series = ''
      } else {
        this.formModel.series = this.yAxisFieldList[Object.keys(this.yAxisFieldList)[0]]
      }
    }
  },
  mounted () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.timer = setTimeout(this.init, 100)
  },
  activated () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.timer = setTimeout(this.init, 100)
  },
  deactivated () {
    this.$refs['viewChart'].destory()
    this.resetData()
  }
}
</script>